export const TAGS_COLORS = {
  violet: "violet",
  green: "green",
  red: "red",
  orange: "orange",
  blue: "blue",
  warmGreen: "warmGreen",
  darkBlue: "darkBlue",
  yellow: "yellow",
};
